<form [formGroup]="formName">
        @if (pKeyFilter === null) {
                <input type="text" 
                appTrimSpaces pInputText
                 [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode" 
                 class="w-full" 
                 [placeholder]="placeholder" 
                 [pattern]="field?.validation?.pattern" 
                 [disabled]="formName.get(field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode)?.disabled"
                 />
        } @else {
                <input type="text" 
                appTrimSpaces pInputText 
                 pInputText 
                 [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode" 
                 [pKeyFilter]="pKeyFilter" 
                 class="w-full" 
                 [placeholder]="placeholder" 
                 [pattern]="field?.validation?.pattern" 
                 [disabled]="formName.get(field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode)?.disabled"/>
        }
</form>